import {
  reactive,
  ref,
  toRefs,
  h,
  createVNode,
  render
} from 'vue'
import { removeClass } from '@sgui-plus/utils/dom'
import loadingVue from './loading.vue'
import type { LoadingOptionsResolved, LoadingParentElement } from './types'

export function createLoadingComponent(options: LoadingOptionsResolved) {
  let afterLeaveTimer: number

  const afterLeaveFlag = ref(false)
  const data = reactive({
    ...options,
    originalPosition: '',
    originalOverflow: '',
    onAfterLeave: handleAfterLeave
  })

  const container = document.createElement('div')

  function setText(text: string) {
    data.text = text
  }

  function destroySelf() {
    const target = <LoadingParentElement>data.parentEl
    if (!target.vLoadingAddClassList) {
      let loadingNumber: number | string | null = target.getAttribute('loading-number')
      loadingNumber = Number.parseInt(loadingNumber as any) - 1
      if (!loadingNumber) {
        removeClass(target, 'sg-loading-parent--relative')
        target.removeAttribute('loading-number')
      } else {
        target.setAttribute('loading-number', loadingNumber.toString())
      }
      removeClass(target, 'sg-loading-parent--hidden')
    }
    remvoeElLoadingChild()
    render(null, container)
  }

  function remvoeElLoadingChild(): void {
    vm.el?.parentNode?.removeChild(vm.el)
  }

  function close() {
    if (options.beforeClose && !options.beforeClose()) return

    const target = data.parentEl
    target.vLoadingAddClassList = undefined
    afterLeaveFlag.value = true
    clearTimeout(afterLeaveTimer)

    afterLeaveTimer = window.setTimeout(() => {
      if (afterLeaveFlag.value) {
        afterLeaveFlag.value = false
        destroySelf()
      }
    }, 400)
    data.visible = false

    options.closed?.()
  }

  function hide() {
    close()
  }

  function handleAfterLeave() {
    if (!afterLeaveFlag.value) return
    afterLeaveFlag.value = false
    destroySelf()
  }

  const vm = createVNode(loadingVue, { ...data}, data.render ? { default: () => typeof data.render === 'function' ? data.render(h) : '加载中' } : null)
  render(vm, container)

  return {
    ...toRefs(data),
    setText,
    remvoeElLoadingChild,
    hide,
    close,
    handleAfterLeave,
    vm,
    get $el() {
      return vm.el as HTMLElement
    },
  }
}

export type LoadingInstance = ReturnType<typeof createLoadingComponent>
